"use client"
import { classNames, pageContainerClassName } from "@opensea/ui-kit"
import { fullBleedVariants } from "@/styles/utils/page-container"
import { type TopStickyVariant, topStickyVariants } from "@/styles/utils/sticky"

export function useNavigationTabMenuClassNames() {
  return classNames(pageContainerClassName)
}

type NavigationContainerClassNamesProps = {
  overrides?: {
    topStickyVariant?: TopStickyVariant
  }
}

export function useNavigationContainerClassNames({
  overrides,
}: NavigationContainerClassNamesProps = {}) {
  return classNames(
    fullBleedVariants({
      width: "fullScreen",
    }),
    topStickyVariants({
      variant: overrides?.topStickyVariant ?? "after-hero-header-compact",
    }),
    "z-navigation-tab-menu flex h-14 items-center overflow-x-auto overflow-y-hidden bg-bg-app scrollbar-hidden",
  )
}
